import React, { Component } from "react";
import TruncateText from "../../../../components/truncate";

export default class Description extends Component {
  render() {
    const { description, title = "Description", buttonOpenText, buttonClosedText, characters = 600 } = this.props;
    return (
      <div id={title} className="p-6 flex flex-col gap-4">
        <h3 className="text-lg font-bold">{title}</h3>
        <TruncateText
          buttonClassName={`inline-flex gap-1 items-center border-2 rounded-2xl py-1 px-4 w-fit mt-4 bg-white border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]`}
          buttonClosedText={buttonClosedText}
          buttonOpenText={buttonOpenText}
          text={description}
          characters={characters}
        />
      </div>
    )
  }
}